<template>
	<div v-show="type != 'hidden'" class="c-form-item flex" :style="{'width': compWidth}">
		<label v-if="label !== false" class="c-form-item-label flex-end-center" :style="{'min-width': `${labelLength}em`}"><b v-if="required">*</b>{{label}}</label>
		<div class="c-form-item-content flex-grow-auto flex-wrap">
			<div v-if="type" class="c-form-item-unit" :class="[{'flex-grow-auto': inline}, unitType]" :style="{'width': compUnitWidth}">
				<c-input v-if="unitType == 'input'" v-model="unitData" :type="type" width="100%" height="38" :placeholder="placeholder" :maxlength="maxlength" :decimal="decimal" :limit="limit" :readonly="readonly" :disabled="disabled" :word="inputUnit" :clear-button="clearButton" @click="$emit('click')" @clear="$emit('clear')"></c-input>
			
				<div v-else-if="unitType == 'text'">{{unitData}}</div>
			
				<textarea v-else-if="unitType == 'textarea'" v-model="unitData" :placeholder="placeholder" :maxlength="maxlength" @focus="focusState = true" @blur="focusState = false"></textarea>
			
				<c-radio-group v-else-if="unitType == 'radio'" v-model="unitData">
					<c-radio v-for="(item, i) in options" :key="i" :value="item.value" :disabled="disabled || item.disabled">{{item.name}}</c-radio>
				</c-radio-group>
			
				<c-checkbox-group v-else-if="unitType == 'checkbox'" v-model="unitData">
					<c-checkbox v-for="(item, i) in options" :key="i" :value="item.value" :disabled="disabled || item.disabled">{{item.name}}</c-checkbox>
				</c-checkbox-group>
				
				<c-select v-else-if="unitType == 'select'" v-model="unitData" :options="options" :multiple="multiple" :disabled="disabled"></c-select>
				
				<c-datetime v-else-if="unitType == 'datetime'" v-model="unitData" :type="dateType" :range="dateTimeRange" :placeholder="placeholder" :default-time="defaultTime" :limit="unitLimit"></c-datetime>
				
				<c-color v-else-if="unitType == 'color'" v-model="unitData" :placeholder="placeholder"></c-color>
				
				<c-link v-else-if="unitType == 'link'" v-model="unitData" :type="linkType" :template="linkTemplate"></c-link>
				
				<c-media v-else-if="unitType == 'image'" v-model="unitData" type="image" :value="value" :oss="oss" :size="fileSize" :word="fileWord" :limit="unitLimit" :image-size="imageSize" :button="button">
					<slot name="button"></slot>
				</c-media>

				<c-media v-else-if="unitType == 'video'" v-model="unitData" type="video" :value="value" :oss="oss" :size="fileSize" :word="fileWord" :limit="unitLimit" :button="button">
					<slot name="button"></slot>
				</c-media>

				<c-file v-else-if="unitType == 'file'" v-model="unitData" :type="fileType" :size="fileSize" :word="fileWord" :limit="unitLimit"></c-file>

				<c-editor v-else-if="unitType == 'editor'" ref="editor" :content="unitData" :height="height"></c-editor>
				
				<div v-else-if="unitType == 'region'">
					<div class="region-select flex">
						<div class="flex-grow">
							<c-select v-model="regionProvince" :options="provinceOptions"></c-select>
						</div>
						<div class="flex-grow">
							<c-select v-model="regionCity" :options="cityOptions"></c-select>
						</div>
						<div v-show="countyName" class="flex-grow">
							<c-select v-model="regionCounty" :options="countyOptions"></c-select>
						</div>
					</div>
					<div v-if="addressName" class="region-input">
						<c-input v-model="regionAddress" width="100%" height="38" placeholder="详细街道地址"></c-input>
					</div>
				</div>
			</div>

			<div v-else class="c-form-item-unit custom flex-grow">
				<slot></slot>
			</div>
			
			<div v-if="word || $slots.word" class="c-form-item-word" :style="{'width': inlineWord ? 'auto' : '100%'}">
				{{word}}
				<slot name="word"></slot>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from './store/index.js'
	
	export default {
		name: 'cFormItem',
		
		props: {
			type: String,  // 表单项类型
			
			label: {  // 表单项名称
				type: [String, Boolean],
				default: ''
			},
			
			height: {
				type: [String, Number],
				default: 300
			},
			
			name: [String, Number],  // 字段名
			
			startName: String,  // 时期范围起始日期字段名
			
			endName: String,  // 时期范围结束日期字段名
			
			provinceName: String,  // 省份字段名
			
			cityName: String,  // 城市字段名
			
			countyName: String,  // 区县字段名
			
			addressName: String,  // 详细地址字段名

			required: Boolean,  // 是否必填
			
			disabled: Boolean,  // 是否禁用

			value: {  // 表单默认值
				type: [String, Number, Boolean, Array, Object],
				default: ''
			},

			placeholder: {  // 未填写时的说明
				type: String,
				default: ''
			},
			
			readonly: Boolean,  // 只读
			
			word: String,  // 说明文字
			
			inputUnit: String,  // 文本框单位
			
			inlineWord: {  // 说明文字是否行内显示
				type: Boolean,
				default: true
			},
			
			maxlength: [Number, String],  // 文本框最大长度
			
			decimal: [Number, String],  // 数字文本框小数位数

			options: {  // 选择项
				type: [Array, String],
				default: () => {
					return [];
				}
			},
			
			multiple: Boolean,  // 下拉框是否支持多选
			
			dateType: {  // 时间选择器类型
				type: String,
				default: 'datetime'
			},
			
			oss: Boolean,  // 媒体组件是否使用图片空间选择
			
			fileType: String,
			
			fileSize: [String, Number],
			
			fileWord: String,  // 媒体、文件的描述
			
			limit: [String, Number, Array],  // 内容限制
			
			imageSize: String,  // 图片大小
			
			linkType: String,  // 链接选择器类型（pc、app）
			
			linkTemplate: [String, Number],  // 链接选择器模版
			
			button: [Boolean, String]  ,// 上传媒体文件按钮
			
			clearButton: Boolean,
			
			defaultTime: String
		},
		
		data() {
			return {
				focusState: false,
				unitData: this.value || (this.type == 'checkbox' ? [] : ''),
				
				regionProvince: '',
				regionCity: '',
				regionCounty: '',
				regionAddress: '',
				
				provinceOptions: [],
				cityOptions: [],
				countyOptions: []
			};
		},
		
		computed: {
			...mapState(['itemWidth', 'unitWidth', 'labelLength', 'inline']),
			
			compWidth() {
				return this.inline ? this.parsePixel(this.itemWidth) : 'auto';
			},
			
			isUpload() {
				return ['image', 'video', 'file'].includes(this.type);
			},
			
			unitType() {
				if (['input', 'password', 'hidden', 'number'].includes(this.type)) {
					return 'input';
				}
				return this.type;
			},
			
			unitLimit() {
				if (this.isUpload) {
					return parseInt(this.limit) || 1;
				}
				return this.limit;
			},
			
			compUnitWidth() {
				if (this.inline && (this.type == 'datetime' || this.type == 'region') && this.dateTimeRange) {
					return parseInt(this.labelLength) * 14 + parseInt(this.unitWidth) * 2 + 20 + 'px';
				}
				
				if (!['radio', 'checkbox', 'color', 'image', 'video', 'file'].includes(this.type)) {
					return this.inline ? this.parsePixel(this.unitWidth) : '100%';
				}
				
				return 'auto';
			},
			
			dateTimeRange() {
				return !!(this.startName || this.endName);
			},
			
			regionData() {
				return {
					province: this.regionProvince,
					city: this.regionCity,
					county: this.regionCounty,
					address: this.regionAddress
				}
			}
		},
		
		watch: {
			value(val) {
				this.setData(val);
			},
			
			unitData(val) {
				this.$emit('input', val);
			},
			
			regionProvince(val) {
				if (val) {
					val && this.getRegionOptions('city', val);
				} else {
					this.cityOptions = [];
					this.countyOptions = [];
				}
			},
			
			regionCity(val) {
				if (val) {
					this.getRegionOptions('county', val);
				} else {
					this.countyOptions = [];
				}
			},
			
			regionData(val) {
				this.$emit('input', val);
			}
		},
		
		created() {
			this.store = this.$parent.store;
			this.store.setLabelLength((this.label ? this.label.length : 0) + (this.required ? 1 : 0));
		},
		
		mounted() {
			if (this.type == 'region') {
				this.getRegionOptions('province');
			}
		},

		methods: {
			getRegionOptions(type, pid = 0) {
				this.request({
					url: '/address_library/region',
					data: {
						parent_id: pid
					},
					success: data => {
						this[`${type}Options`] = Array.from(data, item => {
							return {
								name: item.name,
								value: item.id
							}
						});
						
						this.$nextTick(() => {
							if (this._regionInit) {
								type == 'province' && (this.regionProvince = this._regionInit.province);
								type == 'city' && (this.regionCity = this._regionInit.city);
								type == 'county' && (this.regionCounty = this._regionInit.county) && (delete this._regionInit);
							}
						});
					}
				});
			},
			
			getData() {
				switch (this.type) {
				case 'region':
					return this.regionData;
				
				case 'editor':
					return this.$refs.editor.getContent();
					
				default:
					return this.unitData;
				}
			},
			
			setData(val) {
				if (this.type == 'region') {
					this._regionInit = val;
					
					if (this.provinceOptions.length) {
						this.regionProvince = this._regionInit.province;
					}
					this.regionAddress = this._regionInit.address;
				} else {
					this.unitData = val;
				}
			},

			clear() {
				switch (this.type) {
				case 'checkbox':
					this.unitData = [];
					break;
					
				case 'region':
					this.regionProvince = this.regionCity = this.regionCounty = this.regionAddress = '';
					break;
					
				default:
					this.unitData = '';
				}
			}
		}
	};
</script>